import { useFormikContext } from 'formik'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { isStaffUser } from '../../../../utils/user'
import { Divider } from '../../../Divider'
import { FormFieldsContainer } from '../../../Form'
import {
  REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING,
  REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT,
  REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_OWNER,
} from '../RequestEditApplicantAddressModal.constants'
import { useRequestEditApplicantAddressFormFields } from '../RequestEditApplicantAddressModal.hooks'
import { isRequestEditApplicantAddressModalAddressRequired } from '../RequestEditApplicantAddressModal.utils'

import { RequestEditApplicantAddressModalActionField } from './RequestEditApplicantAddressModalActionField'
import { RequestEditApplicantAddressModalApplicantField } from './RequestEditApplicantAddressModalApplicantField'
import { RequestEditApplicantAddressModalBuildingField } from './RequestEditApplicantAddressModalBuildingField'
import {
  getRequestEditApplicantAddressModalBuildingApiParams,
  getRequestEditApplicantAddressModalFlatApiParams,
  getRequestEditApplicantAddressModalFocusBuilding,
  getRequestEditApplicantAddressModalFocusFlat,
  getRequestEditApplicantAddressModalFocusOwner,
  getRequestEditApplicantAddressModalOwnerApiParams,
} from './RequestEditApplicantAddressModalFields.utils'
import { RequestEditApplicantAddressModalFlatField } from './RequestEditApplicantAddressModalFlatField'

import * as styles from './RequestEditApplicantAddressModalFields.module.css'

function RequestEditApplicantAddressModalFields({ focusFieldName }) {
  const { setFieldValue, values } = useFormikContext()

  useRequestEditApplicantAddressFormFields()

  const isStaffOwner = isStaffUser(
    values[REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_OWNER] ||
      EMPTY_OBJECT
  )

  function handleChangeBuilding() {
    setFieldValue(REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT, null)
  }

  const ownerApiParams =
    getRequestEditApplicantAddressModalOwnerApiParams(values)

  const buildingApiParams =
    getRequestEditApplicantAddressModalBuildingApiParams(values, isStaffOwner)

  const flatApiParams = getRequestEditApplicantAddressModalFlatApiParams(
    values,
    isStaffOwner
  )

  const isBuildingNotSelected =
    !values[REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING]
  const isAddressRequired = isRequestEditApplicantAddressModalAddressRequired(
    values[REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_OWNER]
  )

  const focusOwnerField =
    getRequestEditApplicantAddressModalFocusOwner(focusFieldName)
  const focusFlatField = getRequestEditApplicantAddressModalFocusFlat(
    focusFieldName,
    isBuildingNotSelected
  )
  const focusBuildingField = getRequestEditApplicantAddressModalFocusBuilding(
    focusFieldName,
    isBuildingNotSelected
  )

  return (
    <FormFieldsContainer className={styles.formFieldsContainer}>
      <div className={styles.section}>
        <RequestEditApplicantAddressModalActionField />
        <RequestEditApplicantAddressModalApplicantField
          autoFocus={focusOwnerField}
          ownerApiParams={ownerApiParams}
        />
      </div>
      <Divider className={styles.separator} />
      <div className={styles.section}>
        <RequestEditApplicantAddressModalBuildingField
          autoFocus={focusBuildingField}
          buildingApiParams={buildingApiParams}
          required={isAddressRequired}
          onChange={handleChangeBuilding}
          onClear={handleChangeBuilding}
        />
        <RequestEditApplicantAddressModalFlatField
          autoFocus={focusFlatField}
          flatApiParams={flatApiParams}
          flatDisabled={isBuildingNotSelected}
          required={isAddressRequired}
        />
      </div>
    </FormFieldsContainer>
  )
}

export default RequestEditApplicantAddressModalFields
